import React from 'react';

import { fieldSet } from '../styles.module.css';

const FieldSet = ({ children }) => {
  return <div className={fieldSet}>{children}</div>;
};

export default FieldSet;
